import {ServiceBase} from '../ServiceBase';
import {IServiceFactoryExtended} from '../service-factory-extended.interface';
import IPlayerMigration from "../../../common/interfaces/player-migration.interface";
import MIGRATION from "../../../common/const/migration_consts";
import {Check} from "@sparkware/app-utils";

export type ClientVisitAnalyticsParams = {
    migrationToken?: string;
    businessCorrelationId?: string;
}

export class PlayerMigrationService extends ServiceBase implements IPlayerMigration {

    private _businessCorrIdQueryParamName: string = MIGRATION.BUSINESS_CORRELATION_ID_QUERY_PARAM;
    private _businessCorrelationId: string;

    public get businessCorrelationId(): string {
        if (!this._businessCorrelationId) {
            this._businessCorrelationId = this.services.tools.getGuid();
        }
        return this._businessCorrelationId;
    }

    constructor(services: IServiceFactoryExtended) {
        super(services);

        if (this.services.location.currentUri.queryParams.hasParam(this._businessCorrIdQueryParamName)){
            this._onReceivedBusinessCorrIdQueryParam(this.services.location.currentUri.queryParams.getParamValue(this._businessCorrIdQueryParamName));
        }

        //on hybrid, the sendAnalytics method is called directly from migration_hybrid_feature.js
        if (this.isMigrationEnabledFromConfig && !this.services.device.hybrid.isHybrid) {
            this.sendClientVisitAnalytics();
        }
    }

    private _onReceivedBusinessCorrIdQueryParam = (businessCorrelationId: string) => {

        if (!this.services.tools.isGuid(businessCorrelationId)) {
            //There are scenarios when the id we receive in the url is not a valid guid, if this is the case we ignore it and create a new one.
            businessCorrelationId = this.services.tools.getGuid();
        }

        this._businessCorrelationId = businessCorrelationId;
    }

    public sendClientVisitAnalytics(params?: ClientVisitAnalyticsParams): void {
        const data = {
            "MIGRATION_EVENT": {
                "EventCategory": "Visitor",
                "EventAction": "Enter",
                "EventActionData": {
                    "System": this.services.device.hybrid.isHybrid ? "888 app" : "888 web",
                    "Source": (!Check.isEmpty(params?.migrationToken) || this.hasClientBeenLoadedWithMigrationToken()) ? "MRG_Redirect" : "Visitor",
                    "Orientation": "Casino",
                    "TokenIncluded": (!Check.isEmpty(params?.migrationToken) || this.hasClientBeenLoadedWithMigrationToken()),
                    "MigrationCompletionIndication": this.isPlayerMigrated
                }
            }
        };

        const logger = this.services.analytics.getLogger(data);

        logger.setBusinessCorrelationID(params?.businessCorrelationId || this.businessCorrelationId);
        logger.setEventType('MIGRATION_EVENT', 'Log', 'Analytics');
        logger.info();
    }

    public get isPlayerMigrated(): boolean {
      return this.services.cookies.getCookie(MIGRATION.PLAYER_MIGRATED_COOKIE) === "true";
    }

    private hasClientBeenLoadedWithMigrationToken(): boolean {
        return this.services.sessionStorage.getItem(MIGRATION.LOADED_WITH_MIGRATION_TOKEN_SESSION_STORAGE_KEY)?.toLowerCase() === "true";
    }

    public get isMigrationEnabledFromConfig(): boolean {
      return this.services.configuration.servicesConfigs.PlayerMigration.enabledForBrand[this.services.sdk.getBrandID()];
    }
}
